import { Flex } from 'antd';
import styled from 'styled-components';

export const StyledSpinner = styled(Flex)`
  position: absolute;
  inset: 0;
  z-index: 2;
  background-color: rgba(255, 255, 255, 0.8);
`;
